module.exports = __webpack_public_path__ + "static/img/4.39f4d2c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/3/zh/4.png
// module id = aDNL
// module chunks = 0